import React, { useState, useEffect } from 'react';
import { Form, Row, Col, Container, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
//@ts-ignore
import ReactFlagsSelect from 'react-flags-select';
import './CarRegistrationForm.scss';

/**
 * Form that ckecks for violation or vignettes by car registration (license plate)
 *
 * @component - CarRegistrationForm
 * @parentComponents - ViolationCheck and VignetteCheck
 */

const DEFAULT_COUNTRY = 'BG';

interface Props {
  dataCheck: (data: CarRegistrationData) => void;
  clearDirtyState?: () => void;
  setDirtyState: () => void;
  setPersonalNumberInput: boolean;
}

interface CarRegistrationData {
  country: string;
  registrationNumber: string;
  personalNumber?: string;
  vehicleCountry?: string;
}

const CarRegistrationForm = (props: Props) => {
  const { t, i18n } = useTranslation();

  // VEHICLE COUNTRY CODE - DEFAULT BG
  const [vehicleCountry, setVehicleCountry] = useState(DEFAULT_COUNTRY);
  const setVehicleCountryHandler = (countryCode: string) => {
    setVehicleCountry(countryCode);
  };

  // VEHICLE REGISTRATION PLATE NUMBER
  const [vehicleRegistration, setVehicleRegistration] = useState('');
  const setVehicleRegistrationHandler = (event: any) => {
    setVehicleRegistration(event.target.value);
  };

  // PERSONAL ID
  const [personalNumber, setPersonalNumber] = useState('');
  const setPersonalNumberHandler = (event: any) => {
    setPersonalNumber(event.target.value);
  };

  const checkData = () => {
    if (!props.setPersonalNumberInput) {
      props.dataCheck({
        country: vehicleCountry,
        registrationNumber: vehicleRegistration
      });
    } else {
      props.dataCheck({
        country: vehicleCountry,
        registrationNumber: vehicleRegistration,
        personalNumber: personalNumber
      });
    }
    if (props.clearDirtyState) {
      props.clearDirtyState();
    }
  };

  const handleKeyPress = (e: any) => {
    if (e.key === 'Enter') checkData();
  };

  const resetForm = () => {
    setVehicleRegistration('');
    if (props.setPersonalNumberInput) setPersonalNumber('');
    props.setDirtyState();
  };

  const [countriesObj]: any = useState({});

  useEffect(() => {
    //@ts-ignore
    const listOfTranslationKeys = Object.keys(i18n.getDataByLanguage('BG').translations).filter(
      (item) => item.search('countryCode') >= 0
    );

    listOfTranslationKeys.forEach((translationKey) => {
      countriesObj[String(translationKey.split('.')[1])] = t(translationKey);
    });
  }, [i18n.language]);

  return (
    <Container className="CarRegistrationForm fadeIn">
      <Form as={Row} className="formControl">
        {!props.setPersonalNumberInput && (
          <Form.Group as={Col} md={4} className="formGroup">
            <Form.Label className="label">{t('CarRegistrationForm.nationality.label')}</Form.Label>
            <ReactFlagsSelect
              className="ReactFlagsSelect"
              selected={vehicleCountry}
              searchable={true}
              searchPlaceholder={t('CarRegistrationForm.search')}
              onSelect={setVehicleCountryHandler}
              customLabels={countriesObj}
            />
          </Form.Group>
        )}
        <Form.Group as={Col} md={4} className="formGroup">
          <Form.Label className="label">{t('CarRegistrationForm.registrationPlate.label')}</Form.Label>
          <Form.Control
            size="sm"
            value={vehicleRegistration}
            onChange={setVehicleRegistrationHandler}
            onKeyPress={handleKeyPress}
          />
        </Form.Group>
        {props.setPersonalNumberInput && (
          <Form.Group as={Col} md={4} className="formGroup">
            <Form.Label className="label">{t('PersonalDataForm.label')}</Form.Label>
            <Form.Control
              size="sm"
              value={personalNumber}
              onChange={setPersonalNumberHandler}
              onKeyPress={handleKeyPress}
            />
          </Form.Group>
        )}
        <Form.Group as={Col} md={4} className="buttonControl">
          <Button onClick={resetForm} variant="outline-success" className="resetBtn" size="sm">
            {t('CarRegistrationForm.reset')}
          </Button>
          <Button onClick={checkData} variant="success" size="sm">
            {t('CarRegistrationForm.button')}
          </Button>
        </Form.Group>
      </Form>
    </Container>
  );
};

export default CarRegistrationForm;
